import { render, staticRenderFns } from "./show-schedule-vertical-block.vue?vue&type=template&id=5ed76646&scoped=true"
import script from "./show-schedule-vertical-block.vue?vue&type=script&setup=true&lang=js"
export * from "./show-schedule-vertical-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./show-schedule-vertical-block.vue?vue&type=style&index=0&id=5ed76646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed76646",
  null
  
)

export default component.exports